<template>
  <v-app>
    <v-main>
      <v-card
        min-height="500px"
        height="500px"
        width="100%"
        max-width="340px"
        class="loginPan"
      >
        <img :src="logoPath" width="100%" alt="Logo" />

        <v-card-title
          class="justify-center pa-0"
          style="font-size: 1.2rem; font-weight: 500; color: #898989"
        >
          LOGIN
        </v-card-title>

        <v-stepper
          v-model="loginStep"
          class="elevation-0"
          style="background-color: transparent; height: 300px"
        >
          <v-stepper-items>
            <v-stepper-content
              step="1"
              class="elevation-0"
              style="height: 275px; padding: 18px"
            >
              <v-form ref="formUserName" v-model="formUserName">
                <div class="mb-12 mt-4">
                  <v-row>
                    <v-col cols="12" class="pb-0">
                      <v-text-field
                        ref="userId"
                        label="User Name"
                        outlined
                        v-model="userId"
                        :rules="[rules.req]"
                        @keydown.enter.stop.prevent
                        @keyup.enter="validateEmail"
                        :autofocus="true"
                        maxlength="25"
                        @keypress="filterCharNum(event)"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                  <!-- <vue-recaptcha
                    :loadRecaptchaScript="true"
                    :sitekey="capKey"
                    @verify="onVerify"
                    @expired="onExpired"
                    size="100"
                  >
                  </vue-recaptcha> -->
                </div>
                <div
                  style="
                    text-align: center;
                    position: absolute;
                    bottom: 1px;
                    left: 0px;
                    width: 100%;
                  "
                >
                  <v-btn
                    color="primary"
                    style="width: 100%; border-radius:0px 0px 15px 15px;"
                    x-large
                    @click="validateEmail"
                    :disabled="!formUserName"
                    :loading="isLoading"
                  >
                    Continue
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="2" style="height: 275px; padding: 18px">
              <v-form ref="formPassword" v-model="formPassword">
                <div class="mb-0">
                  <div class="pt-0 pb-1 mb-1 justify-center">
                    <v-chip
                      @click="loginStep = 1"
                      style="width: 100%; text-align: center !important"
                      ><v-icon left>mdi-keyboard-backspace</v-icon>
                      {{ userId }}
                    </v-chip>
                  </div>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <v-text-field
                        ref="password"
                        :label="plabel"
                        placeholder=""
                        outlined
                        type="password"
                        v-model="password"
                        :rules="passwordRules"
                        @keydown.enter.stop.prevent
                        @keyup.enter="createPassword"
                        :autofocus="true"
                      ></v-text-field>
                      <v-btn
                        color="primary"
                        @click="forgotPassword"
                        v-if="plabel == 'Password'"
                        text
                        :disabled="EventUrl=='igb-2024'"
                        >Forgot Password?</v-btn
                      >
                      <div v-if="plabel=='Create New Password'" style="font-size:0.7rem; color:gray; text-align:left;">
                        The password should be at least 8 characters long. To make it stronger, use upper and lower case letters, numbers, and symbols like @ # $
                        </div>
                    </v-col>
                  </v-row>
                </div>
                <div
                  style="
                    text-align: center;
                    position: absolute;
                    bottom: 1px;
                    left: 0px;
                    width: 100%;
                  "
                >
                  <v-btn
                    color="primary"
                    style="width: 100%; border-radius:0px 0px 15px 15px;"
                    :disabled="!formPassword"
                    x-large
                    @click="createPassword"
                    :loading="isLoading"
                  >
                    Login
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-form>
            </v-stepper-content>

            <v-stepper-content step="3" style="height: 275px; padding: 18px">
              <v-form ref="formOtp" v-model="formOtp">
                <div class="mb-4">
                  <div class="pt-3 pb-3 mb-3 justify-center">
                    <v-chip
                      @click="loginStep = 1"
                      style="width: 100%; text-align: center !important"
                      ><v-icon left>mdi-keyboard-backspace</v-icon>
                      {{ userId }}
                    </v-chip>
                  </div>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        label="Enter OTP"
                        outlined
                        v-model="otp"
                        hint="Received on your email id."
                        persistent-hint
                        :rules="[rules.req]"
                        @keydown.enter.stop.prevent
                        @keyup.enter="validateOtp"
                        counter
                        maxlength="4"
                        class="otpLetter"
                        :autofocus="true"
                      ></v-text-field>
                    </v-col>
                  </v-row>
                </div>
                <div
                  style="
                    text-align: center;
                    position: absolute;
                    bottom: 1px;
                    left: 0px;
                    width: 100%;
                  "
                >
                  <v-btn
                    color="primary"
                    :loading="isLoading"
                    x-large
                    style="width: 100%; border-radius:0px 0px 15px 15px;"
                    :disabled="!formOtp"
                    @click="validateOtp"
                  >
                    Validate
                    <v-icon right>mdi-arrow-right</v-icon>
                  </v-btn>
                </div>
              </v-form>
            </v-stepper-content>
          </v-stepper-items>
        </v-stepper>
      </v-card>
      <video-background
        :src="bgVPath"
        :poster="bgIPath"
        :sources="[{ src: bgIPath, res: 900, autoplay: true }]"
        style="height: 100vh"
        overlay="linear-gradient(45deg,#2a4ae430,#fb949e6b)"
      >
      </video-background>

      <v-alert v-if="alert.show" :type="alert.type"></v-alert>
      <v-snackbar top v-model="alert.show" :color="alert.color">
        {{ alert.msg }}
      </v-snackbar>
    </v-main>
  </v-app>
</template>

<script>
import VideoBackground from "vue-responsive-video-background-player";
//import VueRecaptcha from "vue-recaptcha";
export default {
  layout: "login",
  components: { "video-background": VideoBackground },
  props: { EventUrl: String },
  data() {
    return {
      alert: {
        color: "success",
        msg: "",
        show: false,
      },
      plabel: "Password",
      logoPath: "",
      isLoading: false,
      loginStep: 1,
      userId: "",
      password: "",
      otp: "",
      otpServer: "",
      formUserName: false,
      formPassword: false,
      formOtp: false,
      formCreatePass: false,
      appData: {
        email: "",
        password: "",
        otp: "",
      },

      rules: {
        req: (val) => (val !== null && val !== "") || "Required!",
        email: (v) =>
          /^(([^<>()[\]\\.,;:\s@']+(\.[^<>()\\[\]\\.,;:\s@']+)*)|('.+'))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/.test(
            v
          ) || "E-mail must be valid",
      },

      passwordRules: [
        (v) => !!v || "Password is required",
        (v) => (v && v.length >= 8) || "Password must have 6+ characters",
        (v) => /(?=.*[A-Z])/.test(v) || "Must have one uppercase character",
        (v) => /(?=.*[a-z])/.test(v) || "Must have one lowercase character",
        (v) => /(?=.*\d)/.test(v) || "Must have one number",
        (v) => /([@#$])/.test(v) || "Must have one special character [@#$]",
      ],
      items: [],
      capKey: "6LddAvIcAAAAAFtPO39lfaDlm2Dvb3m4HwI2dOcp",
      capResponse: "",
    };
  },
  async created() {
    this.logoPath =
      this.$apiPhotoPath + "/assets/" + this.EventUrl + "/logo.jpg";
    this.bgIPath = this.$apiPhotoPath + "/assets/" + this.EventUrl + "/bg.jpg";
    this.bgVPath = this.$apiPhotoPath + "/assets/" + this.EventUrl + "/bg.mp4";
  },
  mounted() {
    this.$store.commit("logoutAll");
  },
  methods: {
    showMsg: function(color, msg) {
      this.alert.color = color;
      this.alert.msg = msg;
      this.alert.show = true;
    },
    filterCharNum: function (evt) {
      evt = evt ? evt : window.event;
      if (
        (evt.charCode > 47 && evt.charCode < 58) ||
        (evt.charCode > 64 && evt.charCode < 91) ||
        (evt.charCode > 96 && evt.charCode < 123)
      ) {
        return true;
      } else {
        evt.preventDefault();
      }
    },
    // onVerify: function(response) {
    //   this.capResponse = response;
    // },
    // onExpired: function() {
    //   this.capResponse = "";
    // },
    forgotPassword: async function() {
      this.isLoading = true;
      await this.$axios
        .put(
          "/VendorApp/forgottenpassword/" + this.userId + "/" + this.EventUrl
        )
        .then((res) => {
          var oRes = res.data;
          if (oRes.status == "Success") {
            this.loginStep = 1;
            this.showMsg("success", "Enter user name for procceed!");
          }
          this.isLoading = false;
        });
    },
    validateEmail: async function() {
      // if (this.capResponse == "") {
      //   this.showMsg("error", "Please verify captcha.");
      //   return;
      // }
      this.capResponse = "";
      const pData = {
        user_id: this.userId,
        url: this.EventUrl,
        capResponse: this.capResponse,
      };
      this.isLoading = true;
      await this.$axios.post("/VendorApp/checkVendor", pData).then((res) => {
        var oRes = res.data;
        if (oRes.status == "Success") {
          if (oRes.result == "LOGIN") {
            this.loginStep = 2;
            this.$refs.password.focus();
          } else if (oRes.result == "NOT EXIST") {
            this.showMsg("error", "Invalid User Name!");
          } else if (oRes.result == "WAIT") {
            this.showMsg("error", "Wait for a minute to regenerate OTP!");
          } else {
            this.loginStep = 3;
            this.otp = "";
          }
        } else if (oRes.status == "Failed") {
          this.showMsg("error", "Invalid User Name!");
        } else {
          this.showMsg("error", "Invalid User Name!");
        }
        this.isLoading = false;
      });
    },
    validateOtp: async function() {
      // if (this.otpServer == this.otp) {
      //   this.plabel = "Create New Password";
      //   this.loginStep = 2;
      // } else {
      //   this.showMsg("error", "Invalid OTP!");
      // }
      const pData = {
        user_id: this.userId,
        url: this.EventUrl,
        otp: this.otp,
      };
      this.isLoading = true;
      await this.$axios.post("/VendorApp/checkVendorOtp", pData).then((res) => {
        var oRes = res.data;
        if (oRes.status == "Success") {
          if (oRes.result == "VALID") {
            this.plabel = "Create New Password";
            this.loginStep = 2;
          } else if (oRes.result == "EXPIRED") {
            this.showMsg("error", "OTP has been expired!");
            this.loginStep = 1;
            this.userId = "";
            this.otp = "";
          } else {
            this.showMsg("error", "Invalid OTP!");
          }
        } else {
          this.showMsg("error", "Failed! Try Again.");
          this.loginStep = 1;
        }
        this.isLoading = false;
      });
    },
    createPassword: async function() {
      this.appData.user_id = this.userId;
      this.appData.password = this.password;
      this.appData.otp = this.otp;

      this.isLoading = true;
      await this.$axios
        .put("VendorApp/changeVendorPassword/" + this.EventUrl, this.appData)
        .then(async (res) => {
          //console.log(res.data);
          if (res.data.status == "Success") {
            await this.$store.commit("setEventInfo", res.data.result);
            
            if (
              res.data.result.vendor_name == "" ||
              res.data.result.vendor_name == null
            ) {
              //this.$router.push("/companyupdate");
              window.location.replace("/companyupdate");
            } else {
              window.location.replace("/app/dashboard");

              //this.$router.push("/app/dashboard");
            }
          } else {
            this.showMsg("error", "Invalid Password!");
          }
          this.isLoading = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },
};
</script>

<style>
.text-center {
  text-align: center;
}
.otpLetter input {
  letter-spacing: 20px;
  text-align: center;
  font-size: 1.6rem;
}
.loginPan {
  position: absolute;
  top: calc(50% - 260px);;
  /* left: calc(50% - 170px); */
  right: 10%;
  z-index: 1000;
  margin: auto;
  padding-top: 0px;
  background-color: rgba(255, 255, 255);
  border-radius: 15px !important;
  box-shadow: 0 0 25px #656565 !important;
}
.video-overlay{
  display: none !important;
}
</style>
